// extracted by mini-css-extract-plugin
module.exports = {"title":"_38d1718","titleWrapper":"_ac55552","open":"_c4c5433","icon":"_36958cf","iconOpen":"_5d4366a"};